import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import AuctionAnalystic from "./components/AuctionAnalystic";
import RightAside from "./components/RightAside";
import AuctionStatus from "./components/AuctionStatus";
import TransactionChart from "./components/TransactionChart";
import PlanExpired from "./components/PlanExpired";
import { useSelector } from "react-redux";
import { handleDateSetUp } from "../../../../helpers/helpers";
import VerificationInfo from "./components/VerificationInfo";
import NewInvites from "./components/NewInvite";


function HomePage() {

  const isDastop = useMediaQuery({ query: "(max-width: 1700px)" });
  const isLaptop = useMediaQuery({ query: "(max-width: 1300px)" });
  const isSmallLaptop = useMediaQuery({ query: "(max-width: 1020px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 880px)" });
  const [subscriptionStatus, setSubscriptionStatus] = useState("active");
  const [daysLeft, setDaysLeft] = useState(0);
  const { organization } = useSelector((pre) => pre?.organizationDetails);
  // const [organization, setOrganization] = useState({
  //   subscriptionPlan: {
  //     expiresOn: "2024-08-16T08:47:38.897Z",
  //     planDuration: 1,
  //     planName: "one year plan",
  //     planPrice: 0,
  //     startedOn: "2024-08-03T08:47:38.897Z",
  //   },
  // });

  useEffect(() => {
    const today = new Date();
    const expirationDate = new Date(
      handleDateSetUp(organization?.subscriptionPlan?.expiresOn)
        .split("-")
        .reverse()
        .join("-")
    );
    const timeDiff = expirationDate.getTime() - today.getTime();
    const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

    if (daysDiff < 0) {
      setSubscriptionStatus("expired");
      setDaysLeft(null);
    } else if (daysDiff <= 10) {
      setSubscriptionStatus("expiring-soon");
      setDaysLeft(daysDiff);
    } else {
      setSubscriptionStatus("active");
      setDaysLeft(null);
    }
  }, [organization]);


  return (
    <div className="flex gap-1">
      <div
        style={{
          width: isTablet
            ? "100%"
            : isSmallLaptop
            ? "65%"
            : isLaptop
            ? "70%"
            : isDastop
            ? "76%"
            : "78.5%",
        }}
        className="gap-1 flex  column"
      >
        <NewInvites/>
        {(subscriptionStatus === "expired" ||
          subscriptionStatus === "expiring-soon") && (
          <PlanExpired
            subscriptionStatus={subscriptionStatus}
            daysLeft={daysLeft}
          />
        )}
        {!organization?.verified && <VerificationInfo />}
        <AuctionAnalystic />
        {/* <AuctionPerformanceChart /> */}

        <TransactionChart />
        {isTablet && <RightAside />}
        <AuctionStatus />
      </div>

      {!isTablet && <RightAside />}
    </div>
  );
}

export default HomePage;
